export namespace Typo {
  export const bigHeader = 'h1';
  export const header = 'h2';
  export const title = 'h3';
  export const regular = 'h4';
}
